import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withOffshoreBunkerEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
